/**
 * 將傳進來的 form 做統一的 validation 設定
 * @param form Form
 * @param button 送交form的按鍵
 * @param validate_params Validate plugin 的參數
 * @param before_observer form檢查完畢,送交form之前要呼叫的事件
 */

window.observeForm = function (form, button, validate_params, before_observer) {
    var validator = null;

    // 確認無誤後送交
    $(button).on("click", function () {
        // 讓送交按鍵不能被重複按
        $(button).prop("disabled", true);
        let before_observer_result = true;

        // 清除 cache
        if (validator !== null) {
            validator.reset();
        }

        if (!$(form).valid(validate_params)) {
            $(button).prop("disabled", false);
        } else {
            if (before_observer != null) {
                before_observer_result = before_observer(form, button);
            }

            if (before_observer_result) {
                // 送交...有未填欄位的話plugin會自動擋下來並且移到未填欄位
                $(button).prop("disabled", false);

                $("#rd_loading").show();

                $(form).trigger("submit");
            } else {
                $(button).prop("disabled", false);
            }
        }
    });

    // 將 form 跟 plugin 綁定
    validator = $(form).validate(validate_params);
};

// ----------------------------------------------------------------
//                使用 jquery-ui 的 tool-tip 做提示
// ----------------------------------------------------------------
$.validator.setDefaults({
    showErrors: function (map, errorList) {
        // there's probably a way to simplify this
        let focussed = document.activeElement;

        if (focussed) {
            let _rd_required = $(focussed).closest(".rd_show_validator_error");

            // 因為這裡取不到select的focus 所以只能把select的事件寫在下面
            if (
                $(focussed).is("input, textarea") &&
                _rd_required.find(".rd_notice").length > 0
            ) {
                _rd_required.find(".rd_notice").remove();
                $(focussed).css("border", "1px solid #ddd");
            }
        }

        $.each(errorList, function (index, error) {
            let element = error.element;
            let target = $(element).closest(".rd_show_validator_error");
            if ($(element).is("input,textarea")) {
                if ($(target).find(".rd_notice").length > 0) {
                    $(target).find(".rd_notice").remove();
                    $(element).css("border", "1px solid #ddd");
                }
                $(element).css("border", "1px solid #dc3545");
            } else if ($(element).is("select")) {
                if ($(target).find(".rd_notice").length > 0) {
                    $(target).find(".rd_notice").remove();
                    $(element)
                        .closest(".rd_required")
                        .find(".selectric")
                        .css("border", "1px solid #ddd");
                }
                $(element)
                    .closest(".rd_required")
                    .find(".selectric")
                    .css("border", "1px solid #dc3545");
                // 要綁定移除錯誤的事件
                $(element).on("change", function () {
                    if ($(this).val() !== "") {
                        $(this)
                            .closest(".rd_required")
                            .find(".rd_notice")
                            .remove();
                        $(this)
                            .closest(".rd_required")
                            .find(".selectric")
                            .css("border", "1px solid #ddd");
                    }
                });
            }

            if ($(element).attr("name") == "privacy") {
                if ($("#rd_privacy_wrong").data("lang") == "jp") {
                    $(target).append(
                        `<div class="txt_warning jp left rd_notice" style="display: block;">${error.message}</div>`
                    );
                } else {
                    $(target).append(
                        `<div class="txt_warning left rd_notice" style="display: block;">${error.message}</div>`
                    );
                }

                $("#rd_privacy_wrong").addClass("wrong");
            } else {
                $(target).append(
                    `<div class="txt_warning rd_notice" style="display: block;">${error.message}</div>`
                );
            }
        });
    },
    invalidHandler: function (form, validator) {
        //若無錯誤則跳過以下步驟
        if (!validator.numberOfInvalids()) return;

        // 以Class「rd_required」為基準，作為捲軸移動參考
        let obj = $(validator.errorList[0].element);
        let top = 0;
        top = obj.closest(".rd_required").offset().top;
        if ($("#rd_header").length) {
            top -= $("#rd_header").height();
        }

        $("html,body").animate(
            {
                scrollTop: top,
            },
            500
        );
    },
});

// ----------------------------------------------------------------
//                        自定義 手機(台灣) 規則
// ----------------------------------------------------------------
$.validator.addMethod(
    "mobile",
    function (value, element) {
        var re = /^09[0-9]{8}$/i;

        return value.length == 0 || re.test(value);
    },
    "手機號碼格式錯誤"
);

// ----------------------------------------------------------------
//                        自定義 E-mail 規則
// ----------------------------------------------------------------
$.validator.methods.email = function (value, element, param) {
    var re =
        /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    return value.length == 0 || re.test(value);
};

// ----------------------------------------------------------------
//        壓掉原本的 date 檢查方式.  Firefox 不支援 'yy-mm-dd' 格式
// ----------------------------------------------------------------
$.validator.methods.date = function (a, b, param) {
    var dashed_date_only = a.match(/^\d{4}-\d{2}-\d{2}$/); // 檢查 yyyy-mm-dd

    return (
        this.optional(b) ||
        !/Invalid|NaN/.test(new Date(a).toString()) ||
        dashed_date_only
    );
};

// ----------------------------------------------------------------
//                   自定義 是否給予的2個欄位的值是相同的規則
// ----------------------------------------------------------------
$.validator.addMethod("equal_values", function (value, element, param) {
    return $(param).val() == value;
});

// ----------------------------------------------------------------
//                          自定義 上圖必填 區域
// ----------------------------------------------------------------
/**
 * rules:{
        image_input: {
            picture: '{ "old_input":"nick_name_icon_o", "div":".rd_image_border" }'
        }
    }
 * @param param JSON 文字 (param 參數只能帶文字進來);  JSON 中,
 *              必須有舊的 input 的 name 以及 要被變色的 div 的 div id / class
 *              例: '{ "old_input":"nick_name_icon_o", "div":".rd_image_border" }'
 */
var picture_input_border_color = null;
$.validator.addMethod(
    "picture",
    function (value, element, param) {
        var params = JSON.parse(param);
        var old_input = $('input[name="' + params.old_input + '"]').val(); // 之前儲存過的圖片的檔名
        var target_div = $(element).closest(params.div); // 要被變更 border color 的 div

        // 沒舊的紀錄, 也沒加新的圖片
        if (old_input == "" && $(element).val() == "") {
            // 記錄舊的顏色
            if (picture_input_border_color == null) {
                picture_input_border_color =
                    target_div.css("border-left-color");
            } // end of if

            // 把 border 改成紅色
            target_div.css({ "border-color": "#dc3545" });

            return false;
        } else {
            // 把 border 恢復成原本顏色
            target_div.css({ "border-color": picture_input_border_color });

            return true;
        } // end of if
    },
    "必需上傳一張圖片"
);

// ----------------------------------------------------------------
//                      自定義 date_range 規則
// ----------------------------------------------------------------
$.validator.addMethod(
    "date_start",
    function (value, element, param) {
        var params = JSON.parse(param);
        var start_input = $('input[name="' + params.start + '"]');
        var end_input = $('input[name="' + params.end + '"]');
        var start_date = start_input.val();
        var end_date = end_input.val();

        if (Date.parse(end_date).valueOf() < Date.parse(start_date).valueOf()) {
            return false;
        } else {
            return true;
        } // end of if
    },
    "起始日期不得大於結束日期"
);

// ----------------------------------------------------------------
//                      　　 唯一值規則
// ----------------------------------------------------------------
/**
 * rules:{
      "film_type[]":{
           unique : 'select[name="film_type[]"]'
       },
    }
 * @param check_for 能夠用來找到所有要比對的dom的字串: 例: 'input[name="country"]'
 */
$.validator.addMethod("unique", function (value, dom, check_for) {
    var less_than_two = true;

    $.each($(check_for), function (index, d) {
        // 如果不是自己（目前focus的dom）
        if (dom != d && $(d).val() == value) {
            less_than_two = false;
        }
    });

    return less_than_two;
});

// ----------------------------------------------------------------
//                      　　 聯絡電話判斷
// ----------------------------------------------------------------
$.validator.addMethod(
    "phone",
    function (value, element) {
        return this.optional(element) || /^[\d|\-|\#|\*|\(|\)]+$/g.test(value);
    },
    "請輸入聯絡電話"
);

// ----------------------------------------------------------------
//                      　　 公司統一編號判斷
// ----------------------------------------------------------------
$.validator.addMethod(
    "taxNumber",
    function (value, element) {
        var invoice_number = value;
        var result = false;

        if (!isNaN(parseInt(invoice_number))) {
            var invoice_number_split = invoice_number
                .split("")
                .map(function (data) {
                    return +data;
                });
            var cardinal_number = new Array(1, 2, 1, 2, 1, 2, 4, 1);
            var compute = 0;
            invoice_number_split.forEach(function (data, i) {
                var t = cardinal_number[i] * data;

                if (t > 9) {
                    t.toString()
                        .split("")
                        .forEach(function (data) {
                            compute += +data;
                        });
                } else {
                    compute += t;
                }
            });

            if (compute % 10 == 0) {
                result = true;
            } else if (
                invoice_number_split[6] == 7 &&
                (compute + 1) % 10 == 0
            ) {
                result = true;
            }
        }

        return this.optional(element) || result;
    },
    "統一編號格式錯誤"
);

// ----------------------------------------------------------------
//                      自定義 CkEditor 規則
// ----------------------------------------------------------------
$.validator.addMethod(
    "ck_editor",
    function (value, element, param) {
        let element_id = $(element).prop("id");
        let element_name = $(element).prop("name");
        let editor_id =
            "cke_" +
            (element_id != undefined && element_id != ""
                ? element_id
                : element_name);
        let editor = $("#" + editor_id);

        if (param === true) {
            if (editor.length > 0) {
                var iframe = editor.find("iframe");
                var body = iframe.contents().find("body");

                if (body.html() != "" && body.html() != "<br>") {
                    editor
                        .closest(".rd_show_validator_error")
                        .find("div:first")
                        .css("border", "1px solid #ddd");
                    editor
                        .closest(".rd_show_validator_error")
                        .find(".rd_notice")
                        .remove();
                    return true;
                } else {
                    editor
                        .closest(".rd_show_validator_error")
                        .find("div:first")
                        .css("border", "1px solid #dc3545");
                    return false;
                }
            } // end of if
        }
        return true;
    },
    "此為必填欄位"
);

// ----------------------------------------------------------------
//                 自定義 numeric 規則 僅數字不可有千分位符號
// ----------------------------------------------------------------
$.validator.addMethod(
    "numeric",
    function (value, element) {
        return this.optional(element) || /^[0-9]+\.?[0-9]*$/.test(value);
    },
    "請輸入數字"
);
// ----------------------------------------------------------------
//                 自定義 tel 數字、5種特殊符號()-+#
// ----------------------------------------------------------------
$.validator.addMethod(
    "tel",
    function (value, element) {
        return this.optional(element) || /^[\d|\(|\)|\-|\+|\#]+$/g.test(value);
    },
    "請輸入聯絡電話"
);
